var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99828 1.5C6.34143 1.5 4.99828 2.84315 4.99828 4.5V28.3153L1.00902 44.2724C0.535659 46.1658 1.96774 48 3.91945 48H48.0771C50.0288 48 51.4609 46.1658 50.9875 44.2724L46.9983 28.3153V4.5C46.9983 2.84314 45.6551 1.5 43.9983 1.5H7.99828ZM7.99828 4.5H43.9983V27H7.99828V4.5ZM7.66945 30L3.91945 45L48.0771 45L44.3271 30H7.66945Z",
    fill: "#current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 39C41 39.8284 40.3284 40.5 39.5 40.5L12.5 40.5C11.6716 40.5 11 39.8284 11 39C11 38.1716 11.6716 37.5 12.5 37.5L39.5 37.5C40.3284 37.5 41 38.1716 41 39Z",
    fill: "#FD6C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/Laptop.ddedc898b91ec2b666d882bee7004ead.svg";
export { ForwardRef as ReactComponent };